















































































import tradingService from '@/services/tradingService';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { Wallet } from '@/store/wallet/types';
import { centsToEuro } from '@/filters/currency';
import { SellOffer } from '@/store/sellOffer/types';
import ExporoTable from '@/components/common/Table.vue';
import ExporoTooltip from '@/components/common/Tooltip.vue';
import Modal from '@/components/common/Modal.vue';

@Component({
  name: 'my-sell-offers-view',
  filters: {
    centsToEuro,
  },
  components: {
    ExporoTable,
    ExporoTooltip,
    Modal,
  },
})
export default class MySellOffersView extends Vue {
  @Action('appState/startLoader') startLoader;
  @Action('appState/stopLoader') stopLoader;
  @Getter('appState/isLoading') isLoading?: boolean;
  @Getter('profile/userId') userId?: number;

  private sellOffers: SellOffer[] = null;
  private modalOpen: boolean = false;
  private deleteId: string = null;

  get tableData(): Array<object> {
    if (this.sellOffers) {
      return this.sellOffers
        .map((sellOffer, index) => ({
          [ this.$t('mySellOffer.table.header', { context: 'id' }) ]: {
            text: sellOffer.id,
            value: sellOffer.id,
          },
          [ this.$t('mySellOffer.table.header', { context: 'contractTitle' }) ]: {
            text: sellOffer.asset.title,
            value: sellOffer.asset.title,
          },
          [ this.$t('mySellOffer.table.header', { context: 'initialMaxPieces' }) ]: {
            text: sellOffer.initial_max_pieces,
            value: sellOffer.initial_max_pieces,
          },
          [ this.$t('mySellOffer.table.header', { context: 'maxPieces' }) ]: {
            text: sellOffer.available,
            value: sellOffer.available,
          },
          [ this.$t('mySellOffer.table.header', { context: 'unitPrice' }) ]: {
            text: this.$options.filters.centsToEuro(sellOffer.unit_price),
            value: sellOffer.unit_price,
          },
          [ this.$t('mySellOffer.table.header', { context: 'total' }) ]: {
            text: this.$options.filters.centsToEuro(sellOffer.total),
            value: sellOffer.total,
          },
          [ this.$t('mySellOffer.table.header', { context: 'state' }) ]: {
            text: this.$t(`mySellOffer.states.${sellOffer.state}`) || sellOffer.state,
            value: this.$t(`mySellOffer.states.${sellOffer.state}`) || sellOffer.state,
          },
          [ this.$t('mySellOffer.table.header', { context: 'total' }) ]: {
            text: this.$options.filters.centsToEuro(sellOffer.total),
            value: sellOffer.total,
          },
          [ this.$t('mySellOffer.table.header', { context: 'actions' }) ]: {
            text: sellOffer.id,
            value: sellOffer.id,
            slotId: `actions-${sellOffer.id}`,
          },
        }));
    }

    return [];
  }

  mounted() {
    this.getSellOffers();
  }

  async getSellOffers() {
    this.modalOpen = false;

    try {
      this.startLoader();
      this.sellOffers = (await tradingService.getSellOffers()).data;
      this.sellOffers = this.sellOffers
        .filter((sellOffer) => sellOffer.user_id == this.userId && sellOffer.brand === 'exporo')
        .sort((a,b) => a.updated_at < b.updated_at ? 1 : -1);
      this.stopLoader();
    } catch (error) {
      console.error(error);
      this.stopLoader();
    }
  }

  async cancelSellOffer() {
    try {
      this.startLoader();
      await tradingService.cancelSellOffer(this.deleteId);
      this.getSellOffers();
    } catch (error) {
      console.error(error);
      this.modalOpen = false;
      this.stopLoader();
    }
  }

  toggleModal(deleteId: string | null) {
    this.modalOpen = !this.modalOpen;
    this.deleteId = deleteId;
  }
};
